import { JepInitialViewProperties, JepMapViewConstraints } from '@jeppesen-foreflight/jmkw-types';

export const DEFAULT_MAP_VIEW_PROPERTIES: JepInitialViewProperties = {
  viewType: '2D',
  center: [-104.9416, 39.74137],
  zoom: 7,
  constraints: {
    rotationEnabled: false,
    minZoom: 2,
    maxZoom: 17
  } as JepMapViewConstraints
};

export const DEFAULT_SCENE_VIEW_PROPERTIES: JepInitialViewProperties = {
  visible: true,
  viewType: '3D',
  center: [-104.9416, 39.74137],
  zoom: 6,
  environment: {
    lighting: {
      type: 'virtual',
      directShadowsEnabled: true // autocasts as new VirtualLighting({ directShadowsEnabled: true })
    }
  },
  camera: {
    position: {
      spatialReference: {
        wkid: 102100
      },
      x: -11681832.474107543,
      y: 4271449.9388739,
      z: 95855.5691224914
    },
    heading: 0.0011187793958673076,
    tilt: 75.96996513505184
  }
  // camera: {
  //   position: {
  //     longitude: -104.9416,
  //     latitude: 39.74137,
  //     z: 2520.71497
  //   },
  //   position: {
  //     longitude: -104.9616,
  //     latitude: 39.7337,
  //     z: 2520.71497
  //   },
  //   heading: 300.02,
  //   tilt: 75.97
  // } // Denver, CO
};
